<template>
  <div class="dispatch-laxit">
    <div class="tabs-mobile" v-if="isMobile">
      <a v-bind:class="{ tab: true, active: activeTabIndex === 0 }" href="javascript:;"
        @click="activeTabIndex = 0">
        LEFT PANEL
      </a>
      <a v-bind:class="{ tab: true, active: activeTabIndex === 1 }" href="javascript:;"
        @click="activeTabIndex = 1">
        RIGHT PANEL
      </a>
    </div>
    <div :class="['panel left-panel', activeTabIndex === 0 && isMobile ? 'active' : '']">
      <div class="search-box">
        <input type="text" :placeholder="$t('dispatch.rsvpSearchPlaceholder')"
          v-model="searchInput" v-on:keyup="search"
        />
      </div>
      <div class="tnc-reservations left-side-table">
        <div class="header">
          Customer / Packages TNC
          <span class="refresh-icon" @click="refresh('tncReservations')">
            <i :class="{'fas fa-sync-alt':true, 'fa-spin':tncLoading}"></i>
            <span class="tooltiptext">Refresh</span>
          </span>
        </div>
        <div class="table-box" @scroll="onScrollPackage">
          <div class="table-loader" v-show="tncLoading && !tncList.length">
            <ellipsis-loader></ellipsis-loader>
            <div class="loader-title">{{ $t('dispatch.rsvpTable.loadingData.title') }}</div>
            <div class="loader-text">{{ $t('dispatch.rsvpTable.loadingData.content') }}</div>
          </div>
          <tnc-reservations v-show="tncList.length" ref="tncReservations" :isMobile="isMobile"></tnc-reservations>
          <transition name="slide-up">
            <div class="infinity-loader" v-show="tncLoading && tncList.length > 0">
              <i class="fas fa-spinner fa-spin"></i> Loading
            </div>
          </transition>
          <div class="empty-reservations" v-show="tncList.length <= 0 && !tncLoading">
            <div class="title">Oops. Looks like we found nothing.</div>
            <div class="content">
              No available reservations/packages as of yet.
            </div>
          </div>
        </div>
        <div class="control">
          <tnc-reservations-control></tnc-reservations-control>
        </div>
      </div>
      <div class="other-reservations left-side-table">
        <div class="header">
          Upcoming / Unrouted
          <span class="refresh-icon" @click="refresh('unrouted')">
            <i :class="{'fas fa-sync-alt':true, 'fa-spin':unroutedLoading}"></i>
            <span class="tooltiptext">Refresh</span>
          </span>
        </div>
        <div class="table-box" @scroll="onScrollUnpackage">
          <div class="table-loader" v-show="unroutedLoading && !unroutedList.length">
            <ellipsis-loader></ellipsis-loader>
            <div class="loader-title">{{ $t('dispatch.rsvpTable.loadingData.title') }}</div>
            <div class="loader-text">{{ $t('dispatch.rsvpTable.loadingData.content') }}</div>
          </div>
          <unrouted-reservations v-show="unroutedList.length" ref="unrouted" :isMobile="isMobile"></unrouted-reservations>
          <transition name="slide-up">
            <div class="infinity-loader" v-show="unroutedLoading && unroutedList.length > 0">
              <i class="fas fa-spinner fa-spin"></i> Loading
            </div>
          </transition>
          <div class="empty-reservations" v-show="unroutedList.length <= 0 && !unroutedLoading">
            <div class="title">Oops. Looks like we found nothing.</div>
            <div class="content">
              No available reservations as of yet.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="toggle-mobile" @click="showMapMobile = !showMapMobile">
      <span v-if="!showMapMobile">Show Map <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Map <i class="fa fa-chevron-down"></i></span>  
    </div>

    <div :class="['middle-panel', showMapMobile ? 'showMapBox' : '']">
      <div class="map-box middle-box">
        <laxit-map></laxit-map>
      </div>
      <div class="drop-box middle-box">
        <dropzone></dropzone>
      </div>
    </div>

    <div :class="['panel right-panel', activeTabIndex === 1 && isMobile ? 'active' : '']">
      <div class="row top">
        <div class="columns small-6">
          <driver-tnc></driver-tnc>
        </div>
        <div class="columns small-6">
          <driver-tcp></driver-tcp>
        </div>
      </div>
      <div class="row bottom">
        <div class="columns small-6">
          <driver-inbound></driver-inbound>
        </div>
        <div class="columns small-6">
          <driver-outbound></driver-outbound>
        </div>
      </div>
      <div class="driver-controls">
        <driver-controls></driver-controls>
      </div>
    </div>

    <results-modal></results-modal>
    <routing-modal></routing-modal>
    <ready-to-go-modal></ready-to-go-modal>
    <notes-modal></notes-modal>
  </div>
</template>

<script>
import Dropzone from './Dropzone'
import TncReservationsControl from './TncReservationsControl'
import ResultsModal from './ResultsModal'
import RoutingModal from './RoutingModal'
import LaxitMap from './Map'
import TncReservations from './TncReservations'
import UnroutedReservations from './UnroutedReservations'
import DriverTnc from './DriverTnc'
import DriverTcp from './DriverTcp'
import DriverOutbound from './DriverOutbound'
import DriverInbound from './DriverInbound'
import DriverControls from './DriverControls'
import ReadyToGoModal from './ReadyToGoModal'
import NotesModal from './NotesModal'
import EllipsisLoader from '@/components/Partials/LoadingAnimation/Ellipsis'
import ApiLaxitDrivers from '@/modules/api/laxit/drivers'

export default {
  name: 'dispatch-laxit',
  components: { TncReservations, UnroutedReservations, LaxitMap, Dropzone, TncReservationsControl, ResultsModal, RoutingModal, EllipsisLoader, DriverTnc, DriverTcp, DriverOutbound, DriverInbound, DriverControls, ReadyToGoModal, NotesModal },
  data () {
    return {
      searchInput: '',
      activeTabIndex: 0,
      isMobile: false,
      showMapMobile: false
    }
  },
  computed: {
    tncLoading () { return this.$store.state.laxit.tncReservations.isLoading },
    tncList () { return this.$store.state.laxit.tncReservations.list },
    unroutedLoading () { return this.$store.state.laxit.unroutedReservations.isLoading },
    unroutedList () { return this.$store.state.laxit.unroutedReservations.list },
    _rtgSuccess () { return this.$store.state.laxit.readyToGo.success },
    _dropzoneSaveSuccess () { return this.$store.state.laxit.dropzone.saveSuccess }

  },
  methods: {
    search (e) {
      if (e.keyCode === 13) {
        this.$store.commit('laxit/setTncReservationsSearch', this.searchInput)
        this.refresh('tncReservations')

        this.$store.commit('laxit/setUnroutedReservationsSearch', this.searchInput)
        this.refresh('unrouted')
      }
    },
    onScrollPackage (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.tncReservations.loadMore()) {
          this.$refs.routingPkgTable.loadMore()
        }
      }
    },
    onScrollUnpackage (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.unrouted.loadMore()) {
          this.$refs.unrouted.loadMore()
        }
      }
    },
    getOndutyDrivers () {
      let self = this
      let laxit = self.$store.state.laxit.onDuty

      if (laxit.loading) { return }

      self.$store.commit('laxit/setOnDutyLoading', true)
      ApiLaxitDrivers.getOnDutyDrivers(self, res => {
        self.$store.commit('laxit/setOnDutyLoading', false)
      })
    },
    refresh (target) {
      if (target === 'tncReservations') {
        if (this.tncLoading) { return }
        this.$store.commit('laxit/setTncReservationsCurrentPage', 1)
        this.$store.commit('laxit/resetTncReservationsList')
      } else {
        if (this.unroutedLoading) { return }
        this.$store.commit('laxit/setUnroutedReservationsCurrentPage', 1)
        this.$store.commit('laxit/resetUnroutedReservationsList')
      }

      if (this.$refs[target].getList()) {
        this.$refs[target].getList()
      }
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  watch: {
    _rtgSuccess (val) {
      let target = this.$store.state.laxit.readyToGo.table
      if (val && target) {
        if (target === 'tncReservations') {
          this.$store.commit('laxit/resetTncReservationsList')
          if (this.$refs.tncReservations.getList()) {
            this.$refs.tncReservations.getList()
          }
        } else {
          this.$store.commit('laxit/resetUnroutedReservationsList')
          if (this.$refs.unrouted.getList()) {
            this.$refs.unrouted.getList()
          }
        }
      }
    },
    _dropzoneSaveSuccess (val) {
      let self = this
      if (val) {
        self.refresh('tncReservations')
        self.refresh('unrouted')
        setTimeout(function () {
          self.$store.commit('laxit/setDropzoneSaveSuccess', false)
        }, 1000)
      }
    }
  },
  mounted () {
    this.setScreenSize()
    this.getOndutyDrivers()
  }
}
</script>

<style lang="scss" scoped>
$left-panel-width: 35%;
$middle-panel-width: 30%;
$right-panel-width: 35%;

.left-panel,
.middle-panel,
.right-panel {
  height: 100%;
  position: fixed;
  top: 0;
}
.left-panel {
  width: $left-panel-width;
  left: 0;
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);
  z-index: 3;
}
.middle-panel {
  width: $middle-panel-width;
  left: $left-panel-width;
  z-index: 2;
}
.right-panel {
  width: $right-panel-width;
  left: ($left-panel-width + $middle-panel-width);
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);
  z-index: 3;

  .top,
  .bottom {
    height: calc((100vh - 80px) / 2);
  }
}

.search-box {
  width: 100%;
  height: 51px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);

  input {
    margin: 0 0 0 50px;
    border-radius: 0;
    padding: 0 5px;
    height: 50px;
    line-height: 50px;
    width: calc(100% - 50px);
    border: 0;
  }
}

.left-side-table {
  height: calc((100vh - 50px) / 2);
  position: relative;

  .header {
    background: #0d79f2;
    padding: 5px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .table-box {
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
  }
}

.refresh-icon {
  i{ margin-left: 5px; }
  .tooltiptext {
    visibility: hidden;
    width: 80px;
    background-color: #4e4e4e;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 1px 0;
    position: absolute;
    z-index: 1;
    opacity: 0;
    transition: opacity .6s;
    top: 120%;
    left: 60%;
    font-size: 14px;
  }
  &:hover {
    cursor: pointer;
    color: #26D97A;

    & .tooltiptext {
      opacity: 1;
      visibility: visible;
    }
  }
}

.middle-box {
  height: 50vh;
  position: relative;
}

.table-loader{
  position: relative;
  width: 100%;
  margin: 50px auto;
  text-align: center;

  & .loader-title{
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .loader-text{
    font-weight: 700;
    font-size: 16px;
    color: #777;
  }
}
.infinity-loader{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: rgba(0,0,0, .6);
  color: #fff;
  transform-origin: bottom center;
  text-align: center;
  font-size: 18px;
  line-height: 40px;
}

.tnc-reservations{
  padding: 30px 0 43px;

  .control {
    padding: 5px 10px;
    background: #3a3a3a;
  }
  .infinity-loader{ bottom: 43px; }
}

.empty-reservations{
  max-width: 450px;
  margin: 50px auto;
  text-align: center;

  & .title {
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .content{
    font-weight: 700;
    font-size: 16px;
    color: #777;
  }
}

.other-reservations{ padding: 30px 0 0; }

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media screen and (max-width: 430px) {
  .tnc-reservations{ 
    .control {
      position: relative;
      bottom: 12px;
    }
  }
  .tabs-mobile {
    position: relative;
    z-index: 1;
    padding-top: 6px;
    padding-left: 51px;
    & .tab {
      display: inline-block;
      background-color: rgba(255,255,255,0);
      font-size: 14px;
      font-weight: 700;
      padding: 10px 20px;
      border: 1px solid rgba(0,0,0,0.2);
      border-bottom: 0;
      text-decoration: none;
      transition: all 250ms;
      width: 49%;
      text-align: center;

      &:not(:first-child) {
      }

      &.active {
        background-color: #f5f5f5;
        pointer-events: none;
      }
    }
  }

  .search-box {
    input {
      margin: 0;
      width: 100%;
    }
  }

  .tab-contents {
    margin-top: -1px;
    border-top: 1px solid rgba(0,0,0,0.2);
    background-color: #f5f5f5;
    position: relative;
    z-index: 0;
    width: 100%;
    height: calc(100% - 102px);

    & .tab-content {
      display: none;
      height: 100%;
      overflow: auto;
      &.active { display: block; }
      &.with-control { height: calc(100% - 80px); }
    }

    & .tab-control {
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #fff;
      width: 100%;
      border-top: 1px solid rgba(0,0,0,0.3);
      padding: 20px 10px;
    }
  }

  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 20;
    text-transform: uppercase;
    font-weight: 900;
  }
  .tab-contents {
    .tab-control {
      bottom: 45px;
      padding: 10px 5px;
    }
  }
  .left-panel {
    width: 100%;
    top: 50px;
    .other-reservations {
      .table-box {
        padding-bottom: 100px;
      }
    }
  }

  .middle-panel {
    left: 0;
    width: 100%;
    top: 100%;
    transition: all 0.3s ease;
    &.showMapBox {
      top: 0;
      z-index: 6;
    }
  }

  .middle-box {
    background-color: #fff;
    &.map-box {
      height: 35vh;
    }
    &.drop-box {
      height: 65vh;
    }
  }

  .right-panel {
    left: 100%;
    width: 100%;
    z-index: 4;
    top: 50px;
    transition: all 0.3s ease;
    background-color: #fff;

    &.active {
      left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Laxit/index.vue